import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-1 mb-1 border-solid border-1 surface-border"
}
const _hoisted_2 = {
  key: 1,
  class: "pt-1 pb-1 flex flex-wrap gap-1 mr-1"
}
const _hoisted_3 = { class: "w-10" }
const _hoisted_4 = {
  key: 0,
  class: "text-800 text-base font-medium mb-1"
}
const _hoisted_5 = {
  key: 1,
  class: "thumbnail-container flex align-items-center justify-content-center h-10rem border-solid border-1 surface-border border-round-sm"
}
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = {
  key: 2,
  class: "w-full h-10rem flex align-items-center justify-content-center border-solid border-1 surface-border border-round-sm"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ban text-6xl font-light text-500" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "text-500 text-sm font-medium overflow-hidden text-overflow-ellipsis" }
const _hoisted_11 = { class: "text-400 text-xs" }
const _hoisted_12 = { class: "download w-2 align-items-center justify-content-center flex" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.attachments.length > 0 && this.$props.attTypeId == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (this.attachments.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.attachments, (att) => {
            return (_openBlock(), _createElementBlock("div", {
              key: att.id,
              class: "shadow-2 p-1 flex surface-card w-15rem",
              style: {"border-radius":"6px"}
            }, [
              _createElementVNode("div", _hoisted_3, [
                ( this.$props.attTypeId == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(att.type.name), 1))
                  : _createCommentVNode("", true),
                (att.thumbnail)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("img", {
                        src: $options.thumbnailUrl(att),
                        alt: "Thumbnail",
                        class: "w-full h-full border-round-sm cursor-pointer",
                        onClick: ($event: any) => ($options.openModal(att))
                      }, null, 8, _hoisted_6)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)),
                _createElementVNode("div", _hoisted_10, _toDisplayString(att.name + "." + att.fileExt), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString($options.formattedFileSize(att.size)), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", {
                  href: this.store.basicUrlDownloadLink + att.id + '?internal=' + this.$props.internal
                }, [
                  _createVNode(_component_PrimevueButton, {
                    icon: "pi pi-download",
                    severity: "secondary",
                    "aria-label": "Download"
                  })
                ], 8, _hoisted_13)
              ])
            ]))
          }), 128)),
          ($data.showModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "modal-overlay",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($options.closeModal && $options.closeModal(...args)), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: $data.modalImage,
                    alt: "Full Image",
                    class: "modal-image"
                  }, null, 8, _hoisted_15),
                  _createElementVNode("button", {
                    class: "modal-close-btn",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.closeModal && $options.closeModal(...args)))
                  }, "X")
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}